import { render, staticRenderFns } from "./eduDrawer.vue?vue&type=template&id=3855f8cb&"
import script from "./eduDrawer.vue?vue&type=script&lang=js&"
export * from "./eduDrawer.vue?vue&type=script&lang=js&"
import style0 from "./eduDrawer.vue?vue&type=style&index=0&id=3855f8cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports